module.exports = __webpack_public_path__ + "img/appraisalB.e482ddfa.png";